import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BaseService} from '../../core/service/base.service';
import {Workday} from './resource/workday';
import {Observable} from 'rxjs';
import {HeaderConstants} from '../../core/utils/headers.constants';

@Injectable()
export class WorkdayService extends BaseService<Workday> {

  serviceUrl(): string {
    return `/api/work-days`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }

  getAll(refresh = false): Observable<Workday[]> {
    const paramsData = new HttpParams();
    const options = {params: paramsData, headers: new HttpHeaders().set(HeaderConstants.CACHED, refresh ? 'false' : 'true')};
    return this.http
      .get<Workday[]>(`${this.serviceUrl()}/all`, options );
  }
}
